'use strict'

import React, { useEffect, useRef } from 'react'

function ModalDialog (props) {
  const modalRef = useRef(null);

  /**
   * Событие закрытия окна через родителя, opened устанавливает именно родитель
   * @param e
   */
  function onClose (e) {
    e.preventDefault()
    document.body.classList.remove('modal-open')
    if (props.hasOwnProperty('onClose'))
      props.onClose()
  }

  useEffect(() => {
    function handleClickOutside(event) {
      if (String(props.type) === 'credit-basket') {
        if (event.target.contains(modalRef.current)) {
          onClose(event); // Закрываем модальное окно
        }
      } else if (modalRef.current && !modalRef.current.contains(event.target)) {
        onClose(event);
      }
    }

    if (props.opened) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [props.opened]);

  useEffect(() => {
    if (props.opened) {
      let obj = document.querySelector('.lt-label-mobile')
      if (obj instanceof HTMLElement) {
        obj.style.display = 'none'
      }
      document.body.classList.add('modal-open')
    } else {
      let obj = document.querySelector('.lt-label-mobile')
      if (obj instanceof HTMLElement) {
        obj.style.display = ''
      }
      document.body.classList.remove('modal-open')
    }
  }, [props.opened])

  return (
    <>
      <div className={`modal-backdrop ${props.opened ? 'in' : ''}`} onClick={onClose}/>
      <div className={`modal fade ${props.opened ? 'in' : ''} ${props.center ? 'center-' : ''}modal modal-wrapper--${props.type}`}
           id="modal-main"
           role="dialog"
           tabIndex="-1">
        <div className={`modal-dialog modal-dialog--${props.type} ${props.middle ? 'middle' : ''}`}>
          <div className={`modal-content modal-content--${props.type} modal--${props.type}`} ref={modalRef}>
            <a href="#" onClick={onClose} className="close-modal" data-dismiss="modal"/>
            <div className={`modal-body modal-body--${props.type}`}>
              {props.children}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default ModalDialog